import { memo } from 'react';
import classnames from 'classnames';
import { BaseEdge, Edge, EdgeLabelRenderer, EdgeProps, getSmoothStepPath } from '@xyflow/react';
import { EdgeTransportInfoType, NodeConnection } from '@lp/features/RoutePlanner/types';
import { RouteLegTypeEnum } from '@/api/apis/route';
import { AVIA_LEG_TYPES } from '@/utils/route';
import { TransportLabel } from './TransportLabel';

type StepEdgeProps = Edge<EdgeTransportInfoType, 'stepEdge'>;

export const StepEdge = memo(
  ({
    sourceX,
    sourceY,
    sourcePosition,
    sourceHandleId,
    targetX,
    targetY,
    targetPosition,
    targetHandleId,
    markerEnd,
    data,
  }: EdgeProps<StepEdgeProps>) => {
    const [edgePath, labelX, labelY] = getSmoothStepPath({
      sourceX,
      sourceY,
      sourcePosition,
      targetX,
      targetY,
      targetPosition,
    });

    const isRightDirection = sourceX < targetX;
    const isCommercial = data?.legType === RouteLegTypeEnum.CommercialFlightAviaLeg;
    const airStrokeArray = isCommercial ? '3 3' : '6 1';
    const strokeDasharray = !data?.legType || !AVIA_LEG_TYPES.includes(data?.legType) ? '' : airStrokeArray;
    const isRightConnection =
      sourceHandleId === NodeConnection.fromMainRight || targetHandleId === NodeConnection.toMainRight;
    const xTranslate = isRightConnection ? '-65%' : '-35%';

    return (
      <>
        <BaseEdge
          path={edgePath}
          markerEnd={markerEnd}
          style={{
            strokeDasharray,
            strokeWidth: isCommercial ? '2' : '1',
          }}
        />
        {!!data && (
          <EdgeLabelRenderer>
            <div
              style={{
                transform: `translate(${xTranslate}, -50%) translate(${labelX}px,${labelY}px)`,
              }}
              className={classnames('nodrag nopan absolute bg-transparent flex flex-col items-center gap-1', {
                'h-11': isCommercial,
              })}
            >
              <TransportLabel data={data} isRightDirection={isRightDirection} />
              {!isCommercial && (
                <div className="flex gap-1 items-center">
                  <span className="text-s-sb text-base-20">{data.time}</span>
                  {data.isReposition && <span className="text-s-sb text-base-20">REP</span>}
                </div>
              )}
            </div>
          </EdgeLabelRenderer>
        )}
      </>
    );
  },
);
